import {dateFilterKeys} from 'shared/lib/filterHelper';

export const PAYMENT_FILTER_KEYS = [
    'status',
    'tariff.id',
    'recurring',
    'auto',
    'sum[gte]',
    'sum[lte]',
    ...dateFilterKeys('created_at'),
    ...dateFilterKeys('payed_at'),
];

export const ADMIN_PAYMENT_FILTER_KEYS = [...PAYMENT_FILTER_KEYS, 'number', 'valid_recurring'];
